import type { ApiRoute, NoBody, NoQueryParams } from "../../api"
import type { OverviewView } from "./OverviewView"

export interface GetVehicleDetailsOverviewPathParams {
	inventoryId: string
}

export const getVehicleDetailsOverviewRoute: ApiRoute<
	GetVehicleDetailsOverviewPathParams,
	NoQueryParams,
	NoBody,
	OverviewView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/overview`,
	method: "get",
	path: "/vehicles/:inventoryId/overview",
}
